export enum DeliveryOrderDetailType {
    Unknown = "Unknown",
    SingleReference = "SingleReference",
    MonoReference = "MonoReference",
    MultiReference = "MultiReference",
    Component = "Component",
}
